import React, { createContext, useContext, useState } from 'react';

const ExchangeDataContext = createContext();

export const ExchangeDataProvider = ({ children }) => {
  const [updateDataGroup, setUpdateDataGroup] = useState({ });
  const [updateDataSurvey, setUpdateDataSurvey] = useState({ });



 

  return (
    <ExchangeDataContext.Provider value={{ updateDataGroup, setUpdateDataGroup ,updateDataSurvey, setUpdateDataSurvey }}>
      {children}
    </ExchangeDataContext.Provider>
  );
};

export const useExchangeData= () => {
  return useContext(ExchangeDataContext);
};